import { styled } from '@mui/material/styles';
import { ReactComponent as Icon } from '@/assets/file.svg';
import classNames from 'classnames';

export const DocumentIcon = styled(
	({ className }: { className?: string }) => (
		<Icon className={classNames('icon', 'document', className)} />
	),
	{
		target: 'DocumentIcon-root',
		label: 'DocumentIcon',
	},
)({
	'& .st0': {
		fill: 'none',
	},
});
